// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"15":"93e32eb8","356":"e7822279","498":"a9dfc637","863":"e4a8acf4","965":"7db6ef00"}[chunkId] + ".css";
};